import { UserInvitesResponse } from "../../types/invites";

export const getAllInvitesModel = (
  response: UserInvitesResponse
): UserInvitesResponse => response;
